



$(document).ready(function(){
	header.headerInit();
	btnRipple('btn-ripple')
	// Home
	home.homeInit();
	// Main padding
	mainPadding();
	AOS.init({
		duration: 1000,
		easing: 'ease-in-out',
		// disable: true
	});
	
});


function mainPadding(){
	let headerOuterHeight = $('header').outerHeight();
	$('main').css({
		'padding-top': headerOuterHeight + 'px'
	})
}
